(function() {
    angular.module("usersModule").controller("UserDetailsController", UserDetailsController)

    UserDetailsController.$inject = [
        "$state",
        "$rootScope",
        "$scope",
        "$stateParams",
        "$uibModal",
        "usersService",
        "userMessagingService"
    ]

    function UserDetailsController(
        $state,
        $rootScope,
        $scope,
        $stateParams,
        $uibModal,
        usersService,
        userMessagingService
    ){
        "use strict"

        $rootScope.title = "Users | WANCO"

        $scope.uiWithoutEmail = false
        $scope.validUsername  = false
        $scope.formSuccess = false
        $scope.formFailure = false

        $scope.roles = [
            { role:"operator", label: "Operator" },
            { role:"admin", label: "Admin" }
        ]

        if ($rootScope.isRoot || $rootScope.isSuperRoot) {
            $scope.roles.push({ role:"root", label: "Root" })
        }

        if ($rootScope.isSuperRoot) {
            $scope.roles.push({ role:"superroot", label: "Super Root" })
        }

        $scope.user = {}
        usersService.getUser($stateParams.user_id).then((data) => {

            $scope.user = data

            $scope.uiWithoutEmail = $scope.user.username === $scope.user.email

            $scope.formData = {
                username:     $scope.user.username     || "",
                role:         $scope.user.role         || "",
                phone:        $scope.user.phone        || "",
                notify_sms:   $scope.user.notify_sms   || false,
                email:        $scope.user.email        || "",
                notify_email: $scope.user.notify_email || false,
                customer_id:  $scope.user.customer_id  || ""
            }
        })

        $scope.checkUsername = () => {
            $scope.validUsername = !$scope.uiWithoutEmail || (String($scope.formData.username).trim().length >= 6 && String($scope.formData.username).trim().toLowerCase().match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ))
        }

        $scope.editUser = (userID) => {

            $scope.submitted = true

            $scope.checkUsername()

            if ($scope.editUserForm.$valid && (!$scope.uiWithoutEmail || $scope.validUsername)) {

                if ($scope.uiWithoutEmail) {
                    $scope.formData.email = $scope.formData.username.trim()
                } else {
                    $scope.formData.email = $scope.formData.email.trim()
                }

                const success = () => {
                    $state.go("users", {}).then(() => {
                        userMessagingService.success("User Successfully Edited")
                    })
                }

                const failure = (error) => {
                    userMessagingService.error(error)
                }

                usersService.editUser(userID, angular.fromJson($scope.formData), success, failure)

            }
        }

        $scope.openUserDeleteModal = function(user) {
            $uibModal.open({
                templateUrl: "app/modals/delete-user-modal.view.html",
                controller:  "DeleteUserModalController",
                resolve: {
                    user: function() {
                        return user
                    }
                }
            }).result.catch(function(res) {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.sendPasswordReset = function(userEmail) {

            const success = () => {
                userMessagingService.success("Password Reset Request Sent to User")
            }

            const failure = (error) => {
                userMessagingService.error(error)
            }

            usersService.requestPasswordReset(userEmail, success, failure)

        }
    }
})()
